

import { withSize } from 'react-sizeme';
import PageHeader from '../components/PageHeader';

export default withSize()(PageHeader);